import { IAuthUserReducer } from "./AuthReducer";

export const AUTH_ACTIONS_REGISTER_REDIRECT_PATH = 'AUTH_ACTIONS_REGISTER_REDIRECT_PATH';
export const AUTH_ACTIONS_LOGIN = 'AUTH_ACTIONS_LOGIN';
export const AUTH_ACTIONS_LOGOUT = 'AUTH_ACTIONS_LOGOUT';

export interface IAuthActionsRegisterRedirectPath {
  type: typeof AUTH_ACTIONS_REGISTER_REDIRECT_PATH,
  payload: string | undefined
}

export interface IAuthActionsLogin {
  type: typeof AUTH_ACTIONS_LOGIN,
  payload: IAuthUserReducer
}

export interface IAuthActionsLogout {
  type: typeof AUTH_ACTIONS_LOGOUT,
  payload: undefined
}

export type AuthActionTypes = 
  IAuthActionsRegisterRedirectPath |
  IAuthActionsLogin |
  IAuthActionsLogout;